
import React, { ReactNode, useState } from 'react';

interface LoadingModalProps {
  children: ReactNode;
}

export const LoadingModal = React.createContext({
  initState: false,
  setInitState: (state: boolean) => {},
});




// Create a component that provides the context value
const LoadingModalProvider: React.FC<LoadingModalProps> =  ({ children }) => {
  const [initState, setInitState] = useState(false);

  return (
    <LoadingModal.Provider value={{ initState, setInitState }}>
      {children}
    </LoadingModal.Provider>
  );
};

export default LoadingModalProvider;
